<template>
	<div class="gb-photoalbum-mng">
		<Loading v-if="loading" opacity="0.5"/>
		<GBPhotoAlbumHeader 
			:display_list_type="display_list_type"
		/>
		<div class="gb-photoalbum-mng-outer">
			<div class="d-flex">
				<GBPhotoAlbumListScheduleHeader 
					v-on:change-list-filter-text="onChangeListFilterText"
				/>
				<GBPhotoAlbumContentHeader
					v-bind:display_list_type="display_list_type"
					v-bind:download_album="download_album"
					v-bind:select_id="list_select_id"
					v-on:download-all="onDownloadAll"
				/>
			</div>
			<div class="d-flex">
				<GBPhotoAlbumSelectList
					v-bind:items="listItems"
					v-bind:filter_text="list_filter_text"
					v-bind:select_id="list_select_id"
					v-on:select-list="onSelectList"
				/>
				<div class="gb-photoalbum-content-outer" v-bind:style="styleContent">
					<div class="content">
						<GBPhotoAlbumContentAlbum 
							v-if="displayPhotoContentAlbum"
							v-bind:items="photo_albums"
							v-bind:select_id="list_select_id"
							v-bind:download_album="download_album"
							v-on:download-album="onDownloadAlbum"
							v-on:delete-album="onDeleteAlbum"
						/>
						<GBPhotoAlbumContentSchedule 
							v-bind:items="schedules"
							v-bind:download_album="download_album"
							v-bind:select_id="list_select_id"
							v-bind:display_list_type="display_list_type"
							v-on:click-schedule="onClickSchedule"
							v-on:download-shedule-album="onDownloadScheduleAlbum"
						/>
					</div>
				</div>
			</div>
		</div><!-- gb-photoalbum-mng-outer -->
		<DialogConfirmDeletePhotoAlbum
			:display="dialog_del_album.display"
			@click-cancel="onClickCancelDeleteAlbum"
			@click-confirm="onClickConfirmDeleteAlbum"
		/>
	</div>
</template>
<script>
import GBPhotoAlbumHeader from './GBPhotoAlbumHeader';
import GBPhotoAlbumListScheduleHeader from './GBPhotoAlbumListScheduleHeader';
import GBPhotoAlbumContentHeader from './GBPhotoAlbumContentHeader';
import GBPhotoAlbumSelectList from './GBPhotoAlbumSelectList';
import GBPhotoAlbumContentAlbum from './GBPhotoAlbumContentAlbum';
import GBPhotoAlbumContentSchedule from './GBPhotoAlbumContentSchedule';
import DialogConfirmDeletePhotoAlbum from './DialogConfirmDeletePhotoAlbum';
import Loading from '../Loading';
import APIClient from '../../classes/APIClient';
import ConoHa from '../../classes/ConoHa';
import Notification from '../../classes/Notification';
import Util from '../../classes/Util';
import {REFERENCE, DISPLAY_LIST_TYPE, ARCHIVE_TYPE, GANTTBOARD_EVENT_ID, DATETIME_FORMAT} from '../../data/Const';
import clonedeep from 'lodash/cloneDeep';

const strftime = require('strftime');

export default {
	name: "GBPhotoAlbumMng",
	data (){
		return{
			display_list_type: null,
			list_filter_text: null,
			list_select_id: null,
			photo_albums: new Array(),
			schedule_list_rows: new Array(),
			schedules: new Array(),
			loading: false,
			dialog_del_album: { display: false },
			delete_album: null,
			api: null,
			conoha: null,
			download_album: false,
		}
	},
	components: {
		GBPhotoAlbumHeader,
		GBPhotoAlbumListScheduleHeader,
		GBPhotoAlbumContentHeader,
		GBPhotoAlbumSelectList,
		GBPhotoAlbumContentAlbum,
		GBPhotoAlbumContentSchedule,
		DialogConfirmDeletePhotoAlbum,
		Loading,
	},
	methods: {
		initData: async function() {
			this.loading = true;
			await this.fetch();
			this.loading = false;
		},
		onUpdateDataSet: function () {
			this.initData();
		},
		onUpdatePhotoAlbum: function() {
			this.$store.dispatch('addNotification', Notification.info('アルバムを同期しました'));
			this.initData();
		},
		onDownloadPhotoAlbum: function() {
			this.download_album = false;
		},
		onChangeListFilterText: function(e) {
			this.list_filter_text = e;
		},
		onSelectList: function(e) {
			this.list_select_id = e;
			let url = '';
			if (this.display_list_type == DISPLAY_LIST_TYPE.PROJECT) {
				url = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/') + '/#' + e;
			} else {
				url = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member'].join('/') + '/#' + e;
			}
			this.$router.push(url);
			this.initData();
		},
		onClickSchedule: function(schedule) {
			let uri = [this.$route.params.contractor_id, 'photoalbum'];
			if (this.display_list_type === DISPLAY_LIST_TYPE.PROJECT)
				uri.push('project', schedule.project_id);
			else
				uri.push('member', schedule.member_id);
			this.$router.push('/' + uri.join('/') + '/#' + schedule.schedule_id);
		},
		getScheduleListRow: async function() {
			this.schedule_list_rows = new Array();
			let list = new Array();
			let id_cond = { ids: [] };
			this.$store.getters.any_display_list(this.display_list_type).forEach(s => {
				id_cond.ids.push(s.code);
			});
			if (id_cond.ids.length == 0) {
				return;
			}

			let cond = {};
			if (this.display_list_type == DISPLAY_LIST_TYPE.PROJECT) {
				cond['project_cond'] = id_cond;
			} else {
				cond['member_cond'] = id_cond;
			}
			return this.api.getPhotoAlbumScheduleListReference(cond)
				.then((res) => {
					let reference_list = res.data;
					this.$store.getters.any_display_list(this.display_list_type).forEach(s => {
						let item = {schedule_list_row: s, reference: true};
						if (reference_list) {
							reference_list.some(r =>{
								if (r.contractor_id == this.$route.params.contractor_id
									&& r.code == s.code) {
										item.reference = r.reference == REFERENCE.TRUE;
										return true;
								}
								return false;
							});
						}
						list.push(item);
					});
					this.schedule_list_rows = list;
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					this.$store.dispatch('addNotification', Notification.error('スケジュールリスト取得に失敗しました'));
				});
		},
		getProjectPhotoAlbums: async function() {
			this.photo_albums = new Array();
			if (this.display_list_type === DISPLAY_LIST_TYPE.MEMBER)
				return;

			if (!this.list_select_id)
				return;

			return this.api.getPhotoAlbumListOfProject(this.list_select_id)
				.then((res) => {
					let list = new Array();
					if (res.data) {
						list = res.data.album_list;
						list.forEach(l =>{
							l.reference = l.reference == REFERENCE.TRUE;
						});
					}
					this.photo_albums = list;
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					this.$store.dispatch('addNotification', Notification.error('アルバム取得に失敗しました'));
				});
		},
		getSchedules: async function() {
			this.schedules = new Array();
			if (!this.list_select_id) {
				return;
			}

			let project_id;
			let member_id;
			if (this.display_list_type == DISPLAY_LIST_TYPE.PROJECT) {
				project_id = this.list_select_id;
			} else {
				member_id = this.list_select_id;
			}
			return this.api.getPhotoAlbumScheduleList({project_id: project_id, member_id: member_id})
				.then((res) => {
					let list = new Array();
					if (res.data) {
						list = res.data;
						list.forEach(s => {
							s.schedule_begin = String(s.schedule_begin).substr(0, 4)+ '年'
												+ String(s.schedule_begin).substr(4, 2) + '月'
												+ String(s.schedule_begin).substr(6, 2) + '日';
							s.schedule_end = String(s.schedule_end).substr(0, 4)+ '年'
												+ String(s.schedule_end).substr(4, 2) + '月'
												+ String(s.schedule_end).substr(6, 2) + '日';
							if (s.last_modified_at) {
								let utc = Util.getUTCFromYMDHMS(s.last_modified_at);
								s.last_modified_at = strftime(DATETIME_FORMAT, new Date(utc));
							}
							s.reference = s.reference == REFERENCE.TRUE;
						});
					}
					this.schedules = list;
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					this.$store.dispatch('addNotification', Notification.error('メンバースケジュール一覧取得に失敗しました'));
				});

		},
		fetch: async function() {
			await this.getScheduleListRow();

			if (this.list_select_id) {
				let index =  this.schedule_list_rows.findIndex(r => r.schedule_list_row.code === this.list_select_id);
				if (index === -1) {
					this.$store.dispatch('addNotification', Notification.error('案件、もしくはスケジュールが削除されました'));
					this.list_select_id = null;
					let uri = [this.$route.params.contractor_id, 'photoalbum'];
					if (this.display_list_type === DISPLAY_LIST_TYPE.PROJECT) {
						uri.push('project');
					} else {
						uri.push('member');
					}
					this.$router.push('/' + uri.join('/'));
				}
			}

			await this.getProjectPhotoAlbums();
			await this.getSchedules();
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		onDownloadAlbum: function(e) {
			this.download_album = true;
			let socketio_id = this.$store.getters.socketioID;
			this.api.downloadArchive(
				e.project_id, e.member_id , e.schedule_id , e.id, socketio_id, null,
				ARCHIVE_TYPE.ALBUM_ALL
			)
				.catch(() => {
					this.download_album = false;
					this.$store.dispatch('addNotification', Notification.error('ダウンロードに失敗しました'));
				});
		},
		onDeleteAlbum: function(e) {
			this.delete_album = e;
			this.dialog_del_album.display = true;
		},
		onClickCancelDeleteAlbum: function() {
			this.dialog_del_album.display = false;
		},
		onClickConfirmDeleteAlbum: function() {
			this.dialog_del_album.display = false;
			this.loading = true;

			let contractor_id = this.$route.params.contractor_id;
			let photoalbum_id = this.delete_album.id;

			this.deleteAlbum(contractor_id, photoalbum_id)
				.then(async () => {
					await this.deleteFromConoHa(this.delete_album.items);
					await this.fetch();
				})
				.catch(() => {
					this.$store.dispatch('addNotification', Notification.error('アルバム削除に失敗しました'));
				})
				.then(() => {
					this.loading = false;
				});
		},
		deleteAlbum: function(contractor_id, photoalbum_id) {
			return this.api.deletePhotoAlbum(photoalbum_id)
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		deleteFromConoHa: function(items) {
			return Util.chunkSplitPromiseAll(items, async (item) => {
				/* サムネイルは残す */
				// await this.conoha.deleteByURI(item.thumbnail_uri);
				await this.conoha.deleteByURI(item.photo_uri);
			});
		},
		onDownloadAll: function() {
			if (!this.list_select_id)
				return;

			this.downLoadProjectAll();
		},
		onDownloadScheduleAlbum: function(schedule) {
			if (!schedule)
				return;

			this.downLoadScheduleAll(schedule);
		},
		downLoadProjectAll: async function() {
			this.download_album = true;
			let socketio_id = this.$store.getters.socketioID;
			await this.api.downloadArchive(this.list_select_id, 
										'', 
										'', 
										'', 
										socketio_id, 
										[], 
										ARCHIVE_TYPE.PROJECT_ALL)
				.catch(() => {
					this.download_album = false;
					this.$store.dispatch('addNotification', Notification.error('ダウンロードに失敗しました'));
				});
		},
		downLoadScheduleAll: async function(schedule) {
			this.download_album = true;
			let socketio_id = this.$store.getters.socketioID;
			await this.api.downloadArchive(schedule.project_id, 
										schedule.member_id, 
										schedule.schedule_id, 
										'', 
										socketio_id, 
										[], 
										ARCHIVE_TYPE.SCHEDULE_ALL)
				.catch(() => {
					this.download_album = false;
					this.$store.dispatch('addNotification', Notification.error('ダウンロードに失敗しました'));
				});
		},
		onPageShow: function(e) {
			if (e.persisted)
				window.location.reload();
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
	},
	computed: {
		styleContent: function() {
			return {
				'max-width': (this.$store.getters.width - this.$store.getters.listWidth) + 'px',
				'height': (this.$store.getters.height - 90) + 'px',
			}
		},
		displayPhotoContentAlbum: function() {
			return this.display_list_type == DISPLAY_LIST_TYPE.PROJECT;
		},
		listItems: function() {
			return clonedeep(this.schedule_list_rows).map(item => {
				return {
					'id': item.schedule_list_row.code,
					'name': item.schedule_list_row.name,
					'reference': item.reference,
				};
			});
		},
	},
	mounted() {
		const regexProject = new RegExp('^/[^/]+/photoalbum/project/?');
		if (location.pathname.search(regexProject) === 0) {
			this.display_list_type = DISPLAY_LIST_TYPE.PROJECT;
		} else {
			this.display_list_type = DISPLAY_LIST_TYPE.MEMBER
		}

		this.api = new APIClient(this.$store);
		this.conoha = new ConoHa(this.$store.getters.datasetManager);
		let id = this.$route.hash.replace('#', '');
		if (id)
			this.list_select_id = id;

		this.initData();
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			listener: this.onUpdatePhotoAlbum,
		});
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.ALBUM_DOWNLOAD,
			listener: this.onDownloadPhotoAlbum,
		});
	},
	created: function() {
		window.addEventListener('pageshow' , this.onPageShow, false);
		window.addEventListener('resize', this.onWindowResize, false);

		this.onWindowResize();
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
		window.removeEventListener('pageshow' , this.onPageShow);
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			listener: this.onUpdatePhotoAlbum,
		});
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.ALBUM_DOWNLOAD,
			listener: this.onDownloadPhotoAlbum,
		});
	},
};
</script>
<style>
	.gb-photoalbum-mng {
		width: 100%;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		transition:1s;
	}
	.gb-photoalbum-mng .gb-photoalbum-mng-outer {
		position: absolute;
		transition: left ease .3s;
	}
	.gb-photoalbum-mng .gb-photoalbum-content-outer {
		background-color: #fefefe;
		z-index: 101;
		overflow-y: hidden;
		overflow-x: hidden;
	}
	.gb-photoalbum-mng .gb-photoalbum-content-outer .content {
		overflow-y: scroll;
		overflow-x: hidden;
		width: 100%;
		height: 100%;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
	}

</style>
